module.exports = __webpack_public_path__ + "a45b68d3105181f5b55f2688aae9ef91.pdf";